export default function getVWRank(rank) {
    var ranks = {
        PLAYER: {
            color: '#3d3d3d',
            prefix: 'Игрок',
        },
        VIP: {
            color: '#1cd41c',
            prefix: 'VIP',
        },
        PREMIUM: {
            color: '#00dada',
            prefix: 'Premium',
        },
        HOLY: {
            color: '#ffba2d',
            prefix: 'Holy',
        },
        IMMORTAL: {
            color: '#f556e8',
            prefix: 'Immortal',
        },
        YOUTUBE: {
            color: '#fd6363',
            prefix: 'YouTube',
        },
        MODER: {
            color: '#4879ea',
            prefix: 'Модер',
        },
        WARDEN: {
            color: '#4879ea',
            prefix: 'Пр. Модер',
        },
        BUILDER: {
            color: '#4caf50',
            prefix: 'Билдер',
        },
        SRBUILDER: {
            color: '#4caf50',
            prefix: 'Пр. Билдер',
        },
        MAPLEAD: {
            color: '#4caf50',
            prefix: 'Гл. Билдер',
        },
        ORGANIZER: {
            color: '#00bebe',
            prefix: 'Организатор',
        },
        DEV: {
            color: '#00bebe',
            prefix: 'Разработчик',
        },
        CHIEF: {
            color: '#4879ea',
            prefix: 'Гл. Модер',
        },
        ADMIN: {
            color: '#00bebe',
            prefix: 'Гл. Админ',
        },
    };
    if (rank == undefined) return ranks;
    else
        return ranks[rank] != undefined
            ? ranks[rank]
            : {
                  color: 'inherit',
                  prefix: rank,
              };
}
